import { ConfigType } from '../../models/api.interface';
import { useQuery } from './useQuery';

export const useGetQuery = <ResponseData>(
  query: string,
  config?: ConfigType,
) => {
  return useQuery<void, ResponseData>('get', query, config);
};
